import { string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { createNumericFormatter } from '../../generators/index.js';
const INTEGER = 'integer';
const IntegerFormatter = createNumericFormatter({
    defaultOptions: {
        normalizeZeros: true,
        scale: 0,
    },
    formatterOptionTypes: {
        thousandsSeparator: string,
    },
    invalidMessage: 'tws.formatter.integer.invalid',
    name: INTEGER,
});
export { INTEGER, IntegerFormatter, };
export default IntegerFormatter;
//# sourceMappingURL=integer.js.map